import { useCallback, useEffect, useMemo, useState } from 'react';
import _, { isArray } from 'lodash';
import { useGetUserInfo } from '../..';
import { systemAPI } from '../../../apis';

const useGetAdsList = () => {
  const userInfo = useGetUserInfo();
  const [adsList, setAdsList] = useState([]);
  const getADSList = useCallback(async () => {
    try {
      const { result } = await systemAPI.getAdsList({ hospitalCode: userInfo.hospCode });
      setAdsList(result?.ADSInfoDetails);
    } catch (error) {
      console.log(error);
    }
  }, [userInfo.hospCode]);

  useEffect(() => {
    (async () => {
      await getADSList();
    })();
  }, [getADSList]);

  const adsItemList = useMemo(() => {
    if (isArray(adsList) && adsList.length > 0) {
      return _.map(adsList, (item) => ({
        text: item.locationDesc,
        value: item.locationCode,
      }));
    }
    return [];
  }, [adsList]);

  return [adsItemList];
};

export default useGetAdsList;
